import { uuid25 } from "../../uuid/dist/uuid25.js";
import { deepMerge } from "../deepMerge.js";
//#region src/utils/collection/term.entity.ts
var createTerm = (value) => deepMerge({
	id: uuid25(),
	name: "",
	physicalName: "",
	domainId: "",
	description: "",
	synonyms: "",
	order: ""
}, value ?? {});
//#endregion
export { createTerm };
